import { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputLeftAddon,
  Image,
  InputRightElement,
  useDisclosure,
  Popover,
  PopoverContent,
  PopoverArrow,
  PopoverHeader,
  PopoverTrigger,
  useOutsideClick,
  useMediaQuery,
  useToast
} from "@chakra-ui/react";

import { Redirect } from 'react-router-dom';
import SearchIcon from './styles/images/search-icon.svg';
import VaultDisplayDsrModule from './VaultDisplayDsrModule';
import { receivedRoomsSearch } from './actions/vault-actions';
import VaultDisplaySearchResultsModule from './VaultDisplaySearchResultsModule';

import { GoChevronDown } from 'react-icons/go';
import { IoIosClose } from 'react-icons/io';
import { determineIsNonCustomerUserAccount } from '../profile/helpers/user-helper';
import DsrDynamicModal from '../digital-sales-room/messages/DsrDynamicModal';
import VaultMobileNavMenu from './VaultMobileNavMenu';
import { getUserSettings } from '../profile/actions/users-profile-actions';
import DynamicAppBannerDisplay from '../global/components/helper-components/components/DynamicAppBannerDisplay';
import { checkIfDismissedBanner, triggerLaunchdeckToast } from '../global/helpers/global-helpers';
import LoggedOutConfirmationModal from '../digital-sales-room/dsr-general-mgmt/LoggedOutConfirmationModal';
import useLaunchdeckModal from '../global/hooks/use-launchdeck-modal';
import { resetManageJoinRoom } from '../digital-sales-room/actions/manage-dsr-member-actions';
import useViewport from '../layout/components/layout/components/Viewport';

function VaultReceivedRoomsPage({
  vaultIsProcessing,
  allUserDsrs,
  fetchVaultData,
  resetFetchVaultData,
  receivedRoomsSearch,
  receivedRoomsSearchResults,
  receivedRoomsSearchIsProcessing,
  userActionRequiredState,
  showDsrModalState,
  userPrivileges,
  // Action
  getUserSettings,
  resetManageJoinRoom,
  //Redux states
  userAccountProfile,
  userSettings,
  isOrgAdmin,
  isMobileView,
  manageJoinRoomRequestOutcome
}) {

  const initRef = useRef(false);
  const { openLaunchdeckModal, closeLaunchdeckModal } = useLaunchdeckModal();
  const { width: layoutWidth } = useViewport();
  const [localState, setLocalState] = useState({
    isLoading: true,
    isMobileView: false,
    isVerified: null,
    isEmptyState: '',
    requestCategory: "initialize-joined-rooms",

    //Data Mgmt
    displayedDsrs: "",

    // UX Management
    isNoOrgUser: "",
    itemsPerPage: 20, // TODO: Allow user configurability
    pageNumber: 1
  })

  // Manage banner
  const [showAlertBanner, setShowAlertBanner] = useState(false)
  const [showDemoConversionBanner, setShowDemoConversionBanner] = useState(false)
  const [offerFreeTrial, setOfferFreeTrial] = useState(false)
  const [freeTrialCode, setFreeTrialCode] = useState("")

  // Manage search bar
  const [displaySearchResults, setDisplaySearchResults] = useState(false)
  const [searchInputValue, setSearchInputValue] = useState("");

  // Manage Sort function
  const [showSortDropdown, setShowSortDropdown] = useState(false)
  const [chosenSortValue, setChosenSortValue] = useState("Latest")

  // UX: Page navigation
  const [chosenStatusTab, setChosenStatusTab] = useState("all-joined-rooms")


  const [modalTransferPayload, setModalTransferPayload] = useState('')
  const toast = useToast();


  useEffect(() => {
    if (!initRef.current) {
      document.title = 'Launchdeck Digital Sales Room'
      document.description =
        'Create customised private digital sales rooms that let Sales & Purchasing teams agree on deals quickly'
      
      fetchVaultData({ requestCategory: "initialize-joined-rooms", pageNumber: 1, itemsPerPage: localState.itemsPerPage, sortRequest: "default", isFetchReceivedRooms: true })
      initRef.current = true
    }
  }, [fetchVaultData, localState.itemsPerPage])


  useEffect(() => {
    if (userAccountProfile) {
      const { userMetaData } = userAccountProfile || {};
      const { productMarketing } = userMetaData || {};
      const { offerFreeTrial, freeTrialCode } = productMarketing || {};

      if (offerFreeTrial && freeTrialCode) {
        setOfferFreeTrial(true)
        setFreeTrialCode(freeTrialCode)
      }
    }
  }, [userAccountProfile])

  useEffect(() => {
    if (!userSettings) {
      getUserSettings({ emailSettingsRequest: false, bannerSettingsRequest: true, checkDemoSignupUserRequest: true })
    } else if (userSettings) {
      const { useDemoSignupUserNudge } = userSettings || {};
      const isNoOrgUser = determineIsNonCustomerUserAccount();

      if (!!useDemoSignupUserNudge) {
        const isDismissedBanner = checkIfDismissedBanner(userSettings, "demo-user-acquistion-reminder")

        if (!!isDismissedBanner) {
          setShowDemoConversionBanner(false)
        } else {
          setShowDemoConversionBanner(true)
        }

      } else if (userPrivileges.subscriptionReminder === true) {

        const requiredBannerType = isNoOrgUser ? "no-org-user-subscribe-reminder" : isOrgAdmin ? "org-admin-subscribe-reminder" : ""

        if (requiredBannerType) {
          const isDismissedBanner = checkIfDismissedBanner(userSettings, requiredBannerType)

          if (!!isDismissedBanner) {
            setShowAlertBanner(false)
          } else {
            setShowAlertBanner(true)
          }
        }
      }
    }
  }, [userSettings, getUserSettings, userPrivileges.subscriptionReminder, isOrgAdmin])



  useEffect(() => {
    if (allUserDsrs) {
      const { isVerified, foundDsrsTotal, displayedDsrs } = allUserDsrs || {};
      const isEmptyState = displayedDsrs ? false : true;

      const isNoOrgUser = determineIsNonCustomerUserAccount();

      setLocalState((prevState) => ({
        ...prevState,
        isLoading: false,
        isVerified,
        isEmptyState,
        displayedDsrs,
        isNoOrgUser: isNoOrgUser || true,
        foundDsrsTotal
      }))

      resetFetchVaultData()
    }

  }, [allUserDsrs, resetFetchVaultData])


  const toggleFilter = (requestCategory, pageNumber, sortRequest) => {
    setLocalState(prevState => ({
      ...prevState,
      pageNumber,
      displayedDsrs: "",
      requestCategory: requestCategory || "buyers-published-dsrs"
    }))

    fetchVaultData({
      requestCategory: requestCategory || "buyers-published-dsrs",
      sortRequest: sortRequest ? sortRequest : "default",
      pageNumber: pageNumber ? pageNumber : 1,
      itemsPerPage: parseInt(localState.itemsPerPage),
      isFetchReceivedRooms: true
    })

    setDisplaySearchResults(false)
  }

  const onTextSearch = (query) => {
    let sortRequest = "default";

    switch (chosenSortValue) {
      case ('Latest'): {
        sortRequest = "latest"
        break;
      }
      case ('Room name (A - Z)'): {
        sortRequest = "a-to-z"
        break;
      }
      case ('Room name (Z - A)'): {
        sortRequest = "z-to-a"
        break;
      }
      default: {
        break;
      }
    }

    const searchDsrMetadata = {
      queryInput: query,
      requestCategory: "buyers-published-dsrs",
      sortRequest
    }

    setDisplaySearchResults(true)
    receivedRoomsSearch(searchDsrMetadata)

  }

  const handlePickTab = (pickedTab) => {

    if (pickedTab) {
      let sortRequest = "default";
      let requestCategory = pickedTab === "join-requests" ? "get-join-requests" : "buyers-published-dsrs";
      let customQueryDimension = "";

      const pageNumber = localState.pageNumber || 1 

      setChosenStatusTab(pickedTab)
      toggleFilter(requestCategory, pageNumber, sortRequest, customQueryDimension)
    }
  }

  // Note: This useEffect uses the handlePickTab function and needs to placed below it
  useEffect(() => {
    if (manageJoinRoomRequestOutcome) {
      const { updateSuccessful, responsePayload, eventProcessed } = manageJoinRoomRequestOutcome || {};

      if (updateSuccessful && eventProcessed === "delete-join-request") {
        const { removedJoinRequestDsrTitle } = responsePayload || {}
        toast(
          triggerLaunchdeckToast({
            useCase: "show-success-state",
            bannerText: "All done",
            label: `Your request to join ${removedJoinRequestDsrTitle || "the Room"} has been removed`,
            isMobileView
          })
        )

        closeLaunchdeckModal()
        resetManageJoinRoom()
        handlePickTab('join-requests')
      }

    }

  }, [manageJoinRoomRequestOutcome])

  const resetAllFilterValues = () => {
    setChosenSortValue("Latest")
  }

  const handleClearSearch = () => {
    toggleFilter("buyers-published-dsrs", 1, "default")
    setDisplaySearchResults(false)
    setSearchInputValue("")
    resetAllFilterValues()
  }


  // Master close all modals
  const handleDsrModalClose = () => {
    closeLaunchdeckModal()
  }

  const renderVaultPageDisplay = () => {
    const { isLoading, foundDsrsTotal, itemsPerPage, pageNumber, requestCategory,
      isOnboarded, isEmptyState, displayedDsrs, isNoOrgUser } = localState;

    if (isLoading === false) {
      if (isOnboarded === false && !isNoOrgUser) {
        return <Redirect to={'/welcome'} />
      }

      if (isEmptyState === false || isEmptyState === null) {

        if (displaySearchResults === true) {
          return (
            <>
              <VaultSearchToolbar
                onTextSearch={onTextSearch}
                toggleFilter={toggleFilter}
                showSortDropdown={showSortDropdown}
                setShowSortDropdown={setShowSortDropdown}
                chosenSortValue={chosenSortValue}
                setChosenSortValue={setChosenSortValue}
                searchInputValue={searchInputValue}
                setSearchInputValue={setSearchInputValue}
                isMobileView={isMobileView}
              />
              <Box className="display-dsr-container">
                <VaultDisplaySearchResultsModule
                  vaultSearchResults={receivedRoomsSearchResults}
                  itemsPerPage={itemsPerPage}
                  currentPageNumber={pageNumber}
                  isMobileView={isMobileView}
                  vaultSearchIsProcessing={receivedRoomsSearchIsProcessing}
                  chosenSortValue={chosenSortValue}
                  isReceivedRoomsPage={true}
                  handleClearSearch={handleClearSearch}
                />
              </Box>
            </>
          )
        } else {
          return (
            <>
              <VaultReceivedRoomsToolbar
                displaySearchResults={displaySearchResults}
                toggleFilter={toggleFilter}
                onTextSearch={onTextSearch}
                pageNumber={localState.pageNumber}
                showSortDropdown={showSortDropdown}
                setShowSortDropdown={setShowSortDropdown}
                chosenSortValue={chosenSortValue}
                setChosenSortValue={setChosenSortValue}
                searchInputValue={searchInputValue}
                setSearchInputValue={setSearchInputValue}
                isMobileView={isMobileView}
                layoutWidth={layoutWidth}

                handlePickTab={handlePickTab}
                chosenStatusTab={chosenStatusTab}
              />
              <Box className="display-dsr-container">
                <VaultDisplayDsrModule
                  requestCategory={requestCategory}
                  displayedDsrs={displayedDsrs}
                  isMobileView={isMobileView}
                  vaultIsProcessing={vaultIsProcessing}
                  foundDsrsTotal={foundDsrsTotal}
                  itemsPerPage={itemsPerPage}
                  toggleFilter={toggleFilter}
                  handleClearSearch={handleClearSearch}
                  currentPageNumber={pageNumber}
                  vaultSearchIsProcessing={receivedRoomsSearchIsProcessing}
                  chosenSortValue={chosenSortValue}
                  isReceivedRoomsPage={true}

                  chosenStatusTab={chosenStatusTab}
                  handleChangeUserActionRequired={handleChangeUserActionRequired}
                />
              </Box>
            </>
          )
        }
      }
    }
  }

  // DSR status Management
  const handleChangeUserActionRequired = (newUserActionRequired, modalTransferPayload) => {
    setModalTransferPayload(modalTransferPayload)
    openLaunchdeckModal(newUserActionRequired)
  }

  return (
    <>
      {showDemoConversionBanner && <DynamicAppBannerDisplay bannerType={"demo-conversion-nudge"} isMobileView={isMobileView} />}
      {showAlertBanner && <DynamicAppBannerDisplay bannerType={offerFreeTrial ? "free-trial-subscribe-nudge" : "subscription-nudge"} freeTrialCode={offerFreeTrial && freeTrialCode} isMobileView={isMobileView} />}
      <Box>
        {renderVaultPageDisplay()}
      </Box>
      <Box>
        <DsrDynamicModal
          showDsrModal={showDsrModalState}
          userActionRequired={userActionRequiredState}
          handleDsrModalClose={handleDsrModalClose}
          modalTransferPayload={modalTransferPayload}
        />
        <LoggedOutConfirmationModal />
      </Box>
    </>

  )
}

function VaultReceivedRoomsToolbar({ toggleFilter, onTextSearch, pageNumber,
  showSortDropdown, setShowSortDropdown, chosenSortValue, setChosenSortValue,
  searchInputValue, setSearchInputValue, 
  isMobileView,
  handlePickTab, chosenStatusTab, layoutWidth
}) {
  const sortOrderDropdownRef = useRef(null);
  const { isOpen, onToggle, onClose } = useDisclosure()
  const [isError, setIsError] = useState(false);
  const [isLargerThan1000] = useMediaQuery('(min-width: 1000px)')

  const isAllFilter = (chosenStatusTab === 'all-joined-rooms' || chosenStatusTab === '') ? true : false;
  const isJoinRequestFilter = (chosenStatusTab === 'join-requests') ? true : false;

  useOutsideClick({
    ref: sortOrderDropdownRef,
    handler: () => setShowSortDropdown(false),
  })

  const handleChange = (event) => {
    setSearchInputValue(event.target.value)
    isError && setIsError(false)
  }

  const handleClearSearchText = () => {
    setSearchInputValue("")
    toggleFilter("buyers-published-dsrs", 1, "default")
  }

  const handleEnter = (event) => {
    if (event.key === 'Enter' && event.target.name === "joined-rooms-search-bar") {
      if (searchInputValue.trim().length > 2) {
        onTextSearch(searchInputValue)
        onClose()
      } else {
        setIsError(true)
        onToggle()
      }
    }
  }

  const handlePickSortOption = (option) => {
    let sortRequest = "default";
    switch (option) {
      case ('Latest'): {
        sortRequest = "latest"
        break;
      }
      case ('Room name (A - Z)'): {
        sortRequest = "a-to-z"
        break;
      }
      case ('Room name (Z - A)'): {
        sortRequest = "z-to-a"
        break;
      }
      default: {
        break;
      }
    }
    if (option) {
      setChosenSortValue(option)
      toggleFilter("buyers-published-dsrs", pageNumber, sortRequest)
    }
  }


  return (
    <>
      {!isLargerThan1000 ?
        <VaultMobileNavMenu currentMode="joined-rooms" />
        :
        <Flex w='100%' justify='space-between' align='center'>
          <Box>
            <Box className="page-title">Joined Rooms</Box>
            <Box fontSize='0.8em'> Rooms you're participating as a Guest member</Box>
          </Box>
        </Flex>
      }

      <Flex className='menu-bar' gap='10px' justifyContent='center' flexDirection={['column', 'row']}
        fontSize={isMobileView && '0.875em'}
      >

        <Flex justifyContent={['center', 'flex-start']} gap='0.5em' align='center' w='100%' >
          <Box
            className={isAllFilter ? "chosen-category-tab" : "unchosen-category-tab"}
            onClick={() => !isAllFilter && handlePickTab('all-joined-rooms')}>All</Box>
          <Box
            className={isJoinRequestFilter ? "chosen-category-tab" : "unchosen-category-tab"}
            onClick={() => !isJoinRequestFilter && handlePickTab('join-requests')}>Join requests</Box>
        </Flex>

        {!isJoinRequestFilter &&
          <Flex gap='10px' w='100%' flexDirection={['column', 'row']} justify={'flex-end'} mt={['0.875em', '0']}>

            {/* Show Dropdown bar here */}
            <Flex className={isMobileView ? "filter-menu-mobile" : "filter-menu"} onClick={() => { setShowSortDropdown(!showSortDropdown) }} ref={sortOrderDropdownRef}>
              <Flex>
                <Box mr='0.5em' color='gray.500' fontSize='0.875em' fontWeight='400' lineHeight='1.375em'>Sort:</Box>
                <Box className='chosen-option-text-display'>{chosenSortValue}</Box>
              </Flex>

              <Box as={GoChevronDown} boxSize="0.75em" color="gray.300" />

              <Box className='filter-menu__dropdown' display={showSortDropdown ? 'inline-block' : 'none'}>
                <>
                  <Box className={(chosenSortValue !== 'Latest') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Latest') && handlePickSortOption('Latest')}>Latest</Box>
                  <Box className={(chosenSortValue !== 'Room name (A - Z)') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Room name (A - Z)') && handlePickSortOption('Room name (A - Z)')}>Room name (A - Z)</Box>
                  <Box className={(chosenSortValue !== 'Room name (Z - A)') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Room name (Z - A)') && handlePickSortOption('Room name (Z - A)')}>Room name (Z - A)</Box>
                </>
              </Box>
            </Flex>


            {/* Search bar */}
                  {layoutWidth >= 1080 && 
            <Popover
              isOpen={isOpen}
              onClose={onClose}
            >
              <PopoverTrigger isOpen={isError}>
                <Flex w='100%' justify='space-between' minWidth='max-content' maxWidth={!isMobileView && '256px'}>
                  <InputGroup
                    size="2em"
                    ml={!isMobileView && "1em"}
                    width="100%"
                    maxWidth={['100%', '20em']}
                    borderColor='gray.300'>
                    <InputLeftAddon roundedTopLeft='0.25em' roundedBottomLeft='0.25em'>
                      <Image src={SearchIcon} mx="0.75em" />
                    </InputLeftAddon>
                    <Input
                      name='joined-rooms-search-bar'
                      value={searchInputValue}
                      onChange={handleChange}
                      onKeyDown={handleEnter}
                      placeholder="Search"
                      padding="9px 12px"
                      rounded='0.25em'
                      fontSize='0.875em'
                    />
                    {searchInputValue && <InputRightElement children={<Box as={IoIosClose} cursor='pointer' boxSize='1em' onClick={() => handleClearSearchText()} />} top="0" bottom="0" right="8px" m="auto" />}
                  </InputGroup>
                </Flex>
              </PopoverTrigger>
              <PopoverContent zIndex={4}>
                <PopoverArrow />
                <PopoverHeader fontSize='0.875em'>Type in 3 or more characters to search</PopoverHeader>
              </PopoverContent>
            </Popover>
}

          </Flex>
        }
      </Flex>
    </>

  )

}

function VaultSearchToolbar({ 
  onTextSearch,
  showSortDropdown, 
  setShowSortDropdown, 
  chosenSortValue, 
  setChosenSortValue,
  searchInputValue, 
  setSearchInputValue, 
  toggleFilter, 
  isMobileView
}) {

  const { isOpen, onToggle, onClose } = useDisclosure()
  const sortOrderDropdownRef = useRef(null);

  const [isError, setIsError] = useState(false);
  const [isLargerThan1000] = useMediaQuery('(min-width: 1000px)')

  useOutsideClick({
    ref: sortOrderDropdownRef,
    handler: () => setShowSortDropdown(false),
  })

  const handleChange = (event) => {
    setSearchInputValue(event.target.value)
    isError && setIsError(false)
  }

  const handleClearSearchText = () => {
    setSearchInputValue("")
    toggleFilter("buyers-published-dsrs", 1, "default")
  }

  const handleEnter = (event) => {
    if (event.key === 'Enter') {
      if (event.target.name === "rooms-search-bar") {
        // onTextSearch(searchInputValue)
        if (searchInputValue.trim().length > 2) {
          onTextSearch(searchInputValue)
          onClose()
        } else {
          setIsError(true)
          onToggle()
        }
      }
    }
  }

  const handlePickSortOption = (option) => {

    if (option) {
      setChosenSortValue(option)
    }
  }


  return (
    <>
      {!isLargerThan1000 ?
        <VaultMobileNavMenu currentMode="joined-rooms" />
        :
        <Flex w='100%' justify='space-between' align='center'>
          <Box className="page-title">Joined Rooms</Box>
        </Flex>
      }
      <Flex className='menu-bar' gap='10px' justifyContent='center' flexDirection={['column', 'row']}>
        {!isMobileView &&
          <Flex justifyContent={['center', 'flex-start', 'flex-start', 'flex-start']} align='center' w='100%' >
            <Box className="chosen-category-tab">All</Box>
          </Flex>
        }

        <Flex gap='10px' w='100%' justify='flex-end' flexDirection={['column', 'row', 'row', 'row']} align='center'>

          <Flex className='filter-menu' onClick={() => { setShowSortDropdown(!showSortDropdown) }} ref={sortOrderDropdownRef}>
            <Flex>
              <Box mr='0.5em' color='gray.500' fontSize='0.875em' fontWeight='400' lineHeight='1.375em'>Sort:</Box>
              <Box className='chosen-option-text-display'>{chosenSortValue}</Box>
            </Flex>

            <Box as={GoChevronDown} boxSize="0.75em" color="gray.300" />

            {/* Show Dropdown bar here */}
            <Box className='filter-menu__dropdown' display={showSortDropdown ? 'inline-block' : 'none'}>
              <>
                <Box className={(chosenSortValue !== 'Latest') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Latest') && handlePickSortOption('Latest')}>Latest</Box>
                <Box className={(chosenSortValue !== 'Room name (A - Z)') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Room name (A - Z)') && handlePickSortOption('Room name (A - Z)')}>Room name (A - Z)</Box>
                <Box className={(chosenSortValue !== 'Room name (Z - A)') ? 'filter-menu__dropdown-option-display' : 'filter-menu__dropdown-chosen-option-display'} onClick={() => (chosenSortValue !== 'Room name (Z - A)') && handlePickSortOption('Room name (Z - A)')}>Room name (Z - A)</Box>
              </>
            </Box>

          </Flex>


          {/* Search bar */}
          <Popover isOpen={isOpen} onClose={onClose}>
            <PopoverTrigger>
              <Flex w='100%' justify='space-between' minWidth='max-content' maxWidth={!isMobileView && '256px'}>
                <InputGroup
                  size='2em'
                  ml={!isMobileView && "1em"}
                  width="100%"
                  maxWidth={['100%', '20em']}
                  borderColor='gray.300'>
                  <InputLeftAddon roundedTopLeft='0.25em' roundedBottomLeft='0.25em'>
                    <Image src={SearchIcon} mx="0.75em" />
                  </InputLeftAddon><Input
                    name="rooms-search-bar"
                    value={searchInputValue}
                    onChange={handleChange}
                    onKeyDown={handleEnter}
                    placeholder="Search"
                    padding="9px 12px"
                    rounded='0.25em'
                    fontSize='0.875em'
                  />
                  {searchInputValue && <InputRightElement children={<Box as={IoIosClose} cursor='pointer' boxSize='1em' onClick={() => handleClearSearchText()} />} top="0" bottom="0" right="8px" m="auto" />}
                </InputGroup>
              </Flex>
            </PopoverTrigger>
            <PopoverContent
              // isOpen={isError} 
              zIndex={4}>
              <PopoverArrow />
              <PopoverHeader fontSize='0.875em'>Type in 3 or more characters to search</PopoverHeader>
            </PopoverContent>
          </Popover>

        </Flex>
      </Flex>
    </>

  )

}



const mapStateToProps = (state) => ({
  receivedRoomsSearchResults: state.receivedRoomsSearchResults.results.data,
  receivedRoomsSearchIsProcessing: state.receivedRoomsSearchResults.isLoading,
  userActionRequiredState: state.dsrPopup.UserActionRequired,
  showDsrModalState: state.dsrModal.showDsrModal,
  isMobileView: state.mobileViewMode.isMobileView,
  userPrivileges: state.userPrivileges.results,
  userAccountProfile: state.userProfile.accountUserProfile,
  isOrgAdmin: state.isOrgAdmin.results,
  userSettings: state.userSettings.results.data,
  manageJoinRoomRequestOutcome: state.manageJoinRoomRequestOutcome.results.data,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      receivedRoomsSearch,
      getUserSettings,
      resetManageJoinRoom
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VaultReceivedRoomsPage))
